import React from 'react';
import { PropertyListItem } from '../Redesing/property-list-item';
import PropertyListItemLink from '../Redesing/property-list-item-link';
import { SeverityPill } from '../Redesing/severity-pill';

/**
 * "Location" row for the maintenance ticket details card: links to the
 * details page of the location the ticket's hardware is currently assigned
 * to, or shows an "N/A" pill when the hardware has no current location.
 */
const TicketLocationItem = ({
  locationGid,
  locationName,
}: {
  // string | number to match ITicket's legacy index signature
  locationGid?: string | number;
  locationName?: string | number;
}) => {
  if (!locationGid) {
    return (
      <PropertyListItem divider label="Location">
        <SeverityPill color="info">N/A</SeverityPill>
      </PropertyListItem>
    );
  }

  return (
    <PropertyListItemLink
      others={{ divider: true }}
      label="Location"
      text={locationName ?? ''}
      to={`/locations/${locationGid}/general`}
    />
  );
};

export default TicketLocationItem;
